<template>
  <div class="main-wrapper no-padding scroll-y custom-scrollbar with-tabs view-loyalty-activations-single">

    <slide-y-up-transition :duration="800" :delay="200">
      <div v-if="show && data" style="position: relative; text-align: center; margin: 10px 0;">
        <img :src="data.image"/>
      </div>
    </slide-y-up-transition>

    <div class="inner-padding">
      <slide-x-left-transition :duration="400" :delay="200">
        <page-title v-if="show && data" :title="data.title" :back="true" :routeName="'LoyaltyActivations'"></page-title>
      </slide-x-left-transition>
      <slide-x-left-transition :duration="500" :delay="300">
        <h6 v-if="show && data" class="text-up text-gray-light mt-0">{{ data.started_at }} - {{ data.ended_at }}</h6>
      </slide-x-left-transition>
      <slide-x-left-transition :duration="600" :delay="400">
        <div v-if="show && data" class="rte" v-html="data.content"></div>
      </slide-x-left-transition>
      <ion-button mode="ios" expand="block" class="mt-10 mb-10" @click="goBack">
        <span>Zamknij</span>
      </ion-button>
    </div>

  </div>
</template>

<script>
  import api from '@/services/Api';
  import {mapState} from 'vuex';
  import goTo from '@/mixins/goto';
  import PageTitle from '@/components/PageTitle.vue';

  export default {
    name: 'LoyaltyActivationsSingle',
    components: { PageTitle },
    mixins: [goTo],
    computed: {
      ...mapState({
        loading: state => state.loyalty.loading,
        data: state => state.loyalty.activation_single,
      })
    },
    data() {
      return {
        show: false
      }
    },
    mounted() {
      this.show = true;
      this.$store.dispatch('loyalty/LOYALTY_ACTIVATIONS_SINGLE_REQUEST', this.$route.params.slug);
    }
  }
</script>